import { Folder } from 'lucide-react'
import { cn } from '../lib/cn'

export interface PoolItem {
  id: string
  name: string
  documentCount?: number
  status?: 'ready' | 'indexing'
}

export interface PoolPickerProps {
  pools: PoolItem[]
  onPick: (id: string) => void
}

export function PoolPicker({ pools, onPick }: PoolPickerProps) {
  return (
    <div className="overflow-hidden rounded-xl border border-neutral-200 bg-white shadow-lg">
      <div className="px-3 py-2 text-[11px] font-semibold uppercase tracking-wide text-neutral-400">
        Dokumenten Pools
      </div>
      <div className="max-h-72 overflow-y-auto pb-1">
        {pools.map((pool) => (
          <button
            key={pool.id}
            type="button"
            onClick={() => onPick(pool.id)}
            className="flex w-full items-center gap-2.5 px-3 py-2.5 text-left hover:bg-neutral-50"
          >
            <span className="flex h-8 w-8 items-center justify-center rounded-md bg-neutral-100 text-neutral-500">
              <Folder className="h-4 w-4" />
            </span>
            <span className="min-w-0 flex-1">
              <span className="block text-sm font-semibold text-brand-700">@{pool.name}</span>
              <span className="block text-xs text-neutral-500">
                <span
                  className={cn(
                    'mr-1 inline-block h-1.5 w-1.5 rounded-full align-middle',
                    pool.status === 'indexing' ? 'bg-pending' : 'bg-ok',
                  )}
                />
                {pool.documentCount} Dokumente ·{' '}
                {pool.status === 'indexing' ? 'wird indiziert' : 'indiziert'}
              </span>
            </span>
          </button>
        ))}
      </div>
    </div>
  )
}
